import React from 'react';

const Pagination = ({ pagination, currentPage, setCurrentPage, loading }) => {
    if (!pagination || pagination.total === 0) return null;

    const { total, limit, page } = pagination;
    const totalPages = Math.ceil(total / limit);

    if (totalPages <= 1) return null;

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;

        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    className={`btn ${currentPage === i ? 'btn-primary' : 'btn-outline'} btn-xs`}
                    onClick={() => setCurrentPage(i)}
                    style={{ minWidth: '32px', height: '32px', padding: 0 }}
                    disabled={loading}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };

    return (
        <div style={{
            padding: '24px 32px',
            borderTop: '1px solid #f1f5f9',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#fff',
            borderRadius: '0 0 16px 16px'
        }}>
            <div style={{ fontSize: '14px', color: '#64748b', fontWeight: '500' }}>
                Showing <span style={{ color: '#1e293b', fontWeight: '600' }}>{((page - 1) * limit) + 1}</span> to{' '}
                <span style={{ color: '#1e293b', fontWeight: '600' }}>{Math.min(page * limit, total)}</span> of{' '}
                <span style={{ color: '#1e293b', fontWeight: '600' }}>{total}</span> records
            </div>

            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button
                    className="btn btn-outline btn-sm"
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1 || loading}
                    style={{ padding: '6px 12px' }}
                >
                    ◀️ Previous
                </button>

                <div style={{ display: 'flex', gap: '4px' }}>
                    {renderPageNumbers()}
                </div>

                <button
                    className="btn btn-outline btn-sm"
                    onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage >= totalPages || loading}
                    style={{ padding: '6px 12px' }}
                >
                    Next ▶️
                </button>
            </div>
        </div>
    );
};

export default Pagination;
